export default "__VITE_ASSET__8vqwD4hs__"